import { IInterval } from "../../../../Context/Interval";
import { ISystemContext } from "../../../../Context/SystemContext";
import { LogGroup, Size, CreateElement, Scale } from "../../../../MyHelpers";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../../../ResourceManager/SpriteResource";
import { Settings, JackpotDisplayType } from "../../../../Settings";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { Translator } from "../../../../Translator";
import { CanvasSprite } from "../../../Sprite/CanvasSprite";
import { Slide, SlideFactory2Params } from "./Slide";

export class GameTitleJackpotDisplaySlide extends Slide {
	protected logGroup: LogGroup;
	protected resid: ResourceIdentifier;
	protected systemContext: ISystemContext;


    public override translator: Translator;

    //protected maxFreeGames: number = 0;
    protected SpritejackpotTitle: CanvasSprite = null;

    protected container: HTMLElement = null;


   

    protected SripiteTimerLeft: IInterval;
    protected TitleSripiteTimer: IInterval;
    protected jackpot: string = null;



    constructor(initData: SlotGameInitData, p: SlideFactory2Params , viewSize:Size) {
        super(initData, p , viewSize) ;
        this.viewSize = viewSize;
		this.logGroup = 	 this.p.logGroup.Add("GameTitleJackpotDisplaySlide");
		this.resid = 		 this.p.resid.Add("GameTitleJackpotDisplaySlide");
		this.systemContext = this.p.systemContext.CreateSubContext("GameTitleJackpotDisplaySlide");
        

        this.view = CreateElement("div", {
            classes: ["GameTitleJackpotDisplaySlide", this.resid.Scope()],
            style: {
                position: "absolute",
                height: Scale.Hpx(500),
                width: Scale.Wpx(900),
            }
        });

       //this.CreatePath();
    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        this.jackpot = Settings.ResourcesFolder + "multigame/multigame/img/JackpotsResources-Slider/"+Settings.JackpotDisplayType+"/titleJackpotDisplay";
        resourceManager.Add(new SpriteResource(this.jackpot , this.resid.Add("titleJackpotDisplay"), true, this.logGroup.Add("titleJackpotDisplay"), true));
    }  

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotCaliente) {
            this.SpritejackpotTitle = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("titleJackpotDisplay")).sprite, canvasSize: new Size(Scale.W(964), Scale.H(476))});
            this.SpritejackpotTitle.Scale(1.05);
            this.SpritejackpotTitle.View().style.left = Scale.Xpx(50);
        }
        else if ( Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPlayCity) {
            this.SpritejackpotTitle = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("titleJackpotDisplay")).sprite, canvasSize: new Size(Scale.W(1150), Scale.H(500))});
            this.SpritejackpotTitle.ScaleNonUniform(1.2,1);
            this.SpritejackpotTitle.View().style.left = Scale.Xpx(10);
            this.SpritejackpotTitle.View().style.bottom = Scale.Ypx(0);
        }
       else  {
            this.SpritejackpotTitle = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("titleJackpotDisplay")).sprite, canvasSize: new Size(Scale.W(964), Scale.H(476))});
        }
        this.SpritejackpotTitle.View().style.position = "absolute";
        this.view.appendChild(this.SpritejackpotTitle.View());
        this.TitleSripiteTimer = this.systemContext.TimingContext().CreateInterval("GameTitleJackpotDisplaySlider", this.nextAnimInterval, () => this.SpritejackpotTitle.Start(false));
    }

	public override View(): HTMLElement
	{
        return this.view;
	}
	
	public override Update()
	{
        this.SpritejackpotTitle.Update();
	}
	
	public override Start()
	{
        this.TitleSripiteTimer.Start();
    }

	public override Stop()
	{
        this.TitleSripiteTimer.Stop();
        this.SpritejackpotTitle.StopAndReset();
    }
}